import * as Yup from "yup";

export const validationSchemaVacancy = Yup.object({
  fullName: Yup.string().trim().min(3, "Name must be at least 3 characters").required("Full name is required"),

  email: Yup.string().trim().email("Invalid email address").required("Email is required"),

  phone: Yup.string()
    .trim()
    .matches(/^[0-9+\s-]{10,15}$/, "Please enter a valid phone number")
    .required("Phone number is required"),

  experience: Yup.string().trim().required("Experience is required"),

  currentCTC: Yup.string().trim().required("Current CTC is required"),

  expectedCTC: Yup.string().trim().required("Expected CTC is required"),

  resume: Yup.mixed()
    .required("Resume is required")
    .test("fileSize", "File size must be less than 5MB", (value) => value && value.size <= 5 * 1024 * 1024)
    .test("fileType", "Only PDF files are allowed", (value) => value && value.type === "application/pdf"),
});

export const initialValuesVacancy = {
  fullName: "",
  email: "",
  phone: "",
  experience: "",
  currentCTC: "",
  expectedCTC: "",
  resume: null,
};
